<template>
  <PromotionRequestForm />
</template>

<script>
import PromotionRequestForm from '../pages/PromotionRequestForm'

export default {
  components: {
    PromotionRequestForm,
  },

  metaInfo: {
    title: 'Promotion Request System',
  },
}
</script>
